import React, { useEffect, useState } from "react";

import { useNavigate } from "react-router";
import { Container, Button, Tabs, Tab } from "react-bootstrap";
import { EmptyCard, Line, LabelText, CartLayout, SummaryCard, PageWrap, FixedFooter } from "./styles";
import notify from "../../components/UI/toast";
import { LoaderSmall } from "../../components/Loader";
import { useUserData } from "../../hooks/UserContext";
import ErrorBoundary from "../../components/ErrorBoundary";
import Title from "../../components/Title";
import ListTabContent from "./ListTabContent";
import CartFinancialSummary from "./_components/CartFinancialSummary";
import { useSelector, useDispatch } from "react-redux";
import { getCart } from "../../Redux/cartSlice";
import { useApp } from "../../contexts/AppContext";
import { trackBeginCheckoutMarketplaceItems } from "../../utils/gtm";
import { trackClick } from "../../utils/gtm";
import { tagIdFromLegacySuffix } from "../../utils/marketplaceTagIds";
import { useScreenTracking } from "../../hooks/useScreenTracking";
import useMediaQuery from "@mui/material/useMediaQuery";
export default function OrderResume() {
  const navigate = useNavigate();
  const screenName = useScreenTracking();
  const isDesktop = useMediaQuery("(min-width:1024px)");

  const [tab, setTab] = useState("dinheiro");
  const { whitelabel } = useApp();
  const [displayMode, setDisplayMode] = useState(
    whitelabel?.config?.payment_mode,
  );

  useEffect(() => {
    setDisplayMode(whitelabel?.config?.payment_mode);
  }, [whitelabel]);

  const { user, addressShipping, cartItemsError } = useUserData();

  const dispatch = useDispatch();

  const { cart, loading } = useSelector((state) => state.cartSlice);

  useEffect(() => {
    if (user?.uuid) {
      const cep =
        addressShipping?.cep ||
        (user?.addresses?.length ? user.addresses[0].cep : undefined);
      if (cep) {
        dispatch(getCart({ uuid: user.uuid, cep, force: true }));
      }
    }
  }, [user?.uuid, addressShipping?.cep, user?.addresses, dispatch]);

  const sendOrderResumeAnalytics = (customTitle) => {
    trackClick({
      title: customTitle,
      contentType: "checkout",
      screenName,
      tagId: tagIdFromLegacySuffix("15"),
    });
  };

  const handleCheckout = () => {
    // if (cart.warning) {
    //   return;
    // }
    if (disable()) {
      return;
    }

    if (!Object.keys(addressShipping).length) {
      notify("Selecione o endereço de entrega!", "error");
      return;
    }
    trackBeginCheckoutMarketplaceItems(cart?.items);

    sendOrderResumeAnalytics("ir-para-o-resumo");

    navigate("/loja/ordersummary/");
  };

  const disable = () => {
    if (
      cart?.minimum_payments &&
      cart?.minimum_payments?.TIM &&
      tab === "pontos"
    ) {
      if (cart.minimum_payments.TIM > user.balance) {
        return true;
      }
    }
    return false;
  };

  if (loading) return <LoaderSmall />;

  const emptyCart = {
    items: [],
    summary: { shipping: "0", subtotal: "0", total: "0" },
    shipping_by_brand: {},
  };

  const cartActions = (
    <>
      <Button
        type="button"
        className={`btn-default-wl text-xs ${
          cart.warning || (disable() && "disable")
        }`}
        disabled={!cart.items.length || (cartItemsError && cartItemsError.item)}
        onClick={() => handleCheckout()}
      >
        CONTINUAR
      </Button>
      <Button
        type="button"
        className={`btn-outline-wl text-xs ${
          cart.warning || (disable() && "disable")
        }`}
        onClick={() => {
          sendOrderResumeAnalytics("continuar-comprando");
          navigate("/loja");
        }}
      >
        ADICIONAR MAIS ITENS
      </Button>
    </>
  );

  return (
    <>
      <ErrorBoundary>
        <div className="wl-page mt-3">
          <PageWrap>
          <Container>
            <Title label="Carrinho da compra" fontSize="16px" fontWeight={600} />
            <div className="w-full">
              {cart?.items?.length > 0 ? (
                <CartLayout>
                  <div className="cart-list">
                    <Tabs
                      id="controlled-tab-cart"
                      activeKey={tab}
                      onSelect={(k) => setTab(k)}
                      variant="pills"
                      className="skills-tabs mt-4 d-none"
                    >
                      <Tab
                        tabClassName="skills-tab"
                        eventKey="dinheiro"
                        title="Dinheiro"
                      >
                        <ListTabContent
                          items={cart?.items}
                          tab={tab}
                          warning={cart?.warning}
                          shippingByBrandData={cart.shipping_by_brand}
                          displayMode={displayMode}
                        />
                      </Tab>
                    </Tabs>
                    <CartFinancialSummary cart={cart} displayMode={displayMode} />
                  </div>

                  <div className="cart-summary">
                    <SummaryCard>
                      {isDesktop && (
                        <div className="cart-actions">{cartActions}</div>
                      )}
                    </SummaryCard>
                  </div>
                </CartLayout>
              ) : (
                <EmptyCard className="mx-4">
                  <LabelText className="font-wl-500 text-center">
                    Você ainda não adicionou produtos a sua sacola.
                  </LabelText>
                  <div
                    id="goHomeButton"
                    className="d-flex align-items-center justify-content-center"
                  >
                    <Button
                      type="button"
                      className="btn-default-wl text-xxs"
                      style={{ width: 180, heigh: 30 }}
                      onClick={() => navigate("/loja")}
                    >
                      IR PARA HOME
                    </Button>
                  </div>
                  <Line />
                  <CartFinancialSummary cart={emptyCart} displayMode={displayMode} />
                </EmptyCard>
              )}
            </div>
          </Container>
          </PageWrap>
        </div>
        {!isDesktop && (
          <FixedFooter>{cartActions}</FixedFooter>
        )}
      </ErrorBoundary>
    </>
  );
}
